import type { IconData } from '@stacksjs/iconify-core'

export const kw4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGo1QMTd8m\"><path fill-opacity=\".7\" d=\"M0 0h682.7v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGo1QMTd8m)\" transform=\"scale(.9375)\"><path fill=\"#fff\" d=\"M0 170.6h1024v170.7H0z\"/><path fill=\"#f31830\" d=\"M0 341.3h1024V512H0z\"/><path fill=\"#00d941\" d=\"M0 0h1024v170.7H0z\"/><path fill=\"#000001\" d=\"M0 0v512l255.4-170.7l.6-170.8z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default kw4x3
